
import { defineComponent } from 'vue'
export default defineComponent({
  setup (props, context) {
    function payCurrent () {
      context.emit('payCurrent')
    }

    function toHistory () {
      context.emit('toHistory')
    }

    return {
      payCurrent,
      toHistory
    }
  }
})
